import type { BridgeServiceEligibilityStatus } from '@gh/common/models'

const TERMINAL_SE_STATUSES = new Set<BridgeServiceEligibilityStatus>([
  'ELIGIBLE',
  'INELIGIBLE',
  'UNKNOWN',
  'UNINSURED',
  'INEFFECTIVE',
])

export function isTerminalBridgeServiceEligibilityStatus(
  status: BridgeServiceEligibilityStatus,
): boolean {
  return TERMINAL_SE_STATUSES.has(status)
}

export function bridgeCoverageFailureMessage(
  status: BridgeServiceEligibilityStatus | undefined,
): string {
  switch (status) {
    case 'INELIGIBLE':
      return 'Your insurance does not cover this visit. Try another slot or continue as self-pay.'
    case 'UNINSURED':
      return 'No active coverage was found for this visit. Try another slot or continue as self-pay.'
    case 'INEFFECTIVE':
      return 'Your coverage is not effective for this visit date. Try another slot or continue as self-pay.'
    case 'UNKNOWN':
      return 'We could not verify coverage for this visit. Please try again or continue as self-pay.'
    default:
      return status
        ? `Coverage status is ${status}. Please try again or continue as self-pay.`
        : 'Coverage verification failed. Please try again or continue as self-pay.'
  }
}
